$(document).ready(function () {
  let lookSlider = {
    centerPadding: "0px",
    slidesToShow: 2,
    arrows: true,
    prevArrow: $(".look-slider__prev-arrow"),
    nextArrow: $(".look-slider__next-arrow"),
  
    responsive: [
      {
      breakpoint: 900,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: true,
        arrows: false,
        draggable: true,
        dots: false
      }
      }  
    ]
  };

  document.addEventListener("shopify:section:load", function(event) {
    setTimeout(function() {
    $(".look__slider").each(function (index) {
      $(this).slick(lookSlider);
    });
  }, 300);
  });

  $(".look__slider").each(function (index) {
    $(this).slick(lookSlider);
  });

  $(".pointer").on("click", function () {
    var pointerIndex = $(this).data("pointer");

    $(".look__slider").slick("slickGoTo", parseInt(pointerIndex));
  });
});
